import React, { useEffect } from 'react';
import { logout } from '../utils/auth';
import { CONFIG } from '../utils/config';
import { SdfBusyIndicator } from '@waypoint/react-components';

const trimTrailingSlashes = (value = '') => value.replace(/\/+$/, '');

export const buildPostLogoutRedirectUri = () => {
  const postLogoutTarget = CONFIG.POST_LOGIN_REDIRECT_URI || window.location.origin;
  const legacyBase = trimTrailingSlashes(CONFIG.LEGACY_APP_URL || '');

  if (!legacyBase) return postLogoutTarget;

  return `${legacyBase}/logout?continue=${encodeURIComponent(postLogoutTarget)}`;
};

export const LogoutPageComponent = () => {
  useEffect(() => {
    (async () => {
      try {
        await logout(buildPostLogoutRedirectUri());
        setTimeout(() => window.singleSpa.navigateToUrl('/'), 1000);
      } catch (err) {
        console.error('❌ Logout failed:', err);
      }
    })();
  }, []);
  return (
    <SdfBusyIndicator inverse fullscreen size="lg" />
  );
};
